import { render, staticRenderFns } from "./SizeRecommendationResultView.vue?vue&type=template&id=2b9bfcf4&scoped=true"
import script from "./SizeRecommendationResultView.vue?vue&type=script&lang=js"
export * from "./SizeRecommendationResultView.vue?vue&type=script&lang=js"
import style0 from "./SizeRecommendationResultView.vue?vue&type=style&index=0&id=2b9bfcf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9bfcf4",
  null
  
)

/* custom blocks */
import block0 from "./SizeRecommendationResultView.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports